<template>
  <div>
    <div class="login-top">
      <div class="login-conter">
        <div class="login-left">
          <div class="login-content">
            <img :src="require('@/assets/img/avatar.png')" />
          </div>
          <div class="login-content login-text">
            <!-- <span>化工宝数科</span> -->
            <img style="width: 200px;height: 55px;margin-left: 20px;" :src="require('@/assets/img/tanlinbao.png')" alt="">
          </div>
        </div>
        <div class="login-right">
          <!-- <i class="el-icon-search"></i>
          <span class="span">shon Duglas</span> -->
          <!-- <el-avatar
            :size="30"
            src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
          ></el-avatar> -->
        </div>
      </div>
    </div>
    <div style="overflow: hidden;height:90vh;">
      <div class="login-img">
        <div class="login-conterImg">
          <img class="login-bg" :src="require('@/assets/img/main-bg.jpg')" />
          <div class="login-conterImg-c">
            <!-- <div class="login-conterLeft">
              <img src="" />
            </div> -->
            <!-- <p>我是文本内容</p> -->
            <!-- <div class="login-leftImg">
              <img src="../../assets/img/1.png" alt="">
            </div>
            <div class="login-leftImg">
              <img src="../../assets/img/2.png" alt="">
            </div> -->
            <div class="login-conterRight">
              <h2>雨林碳惠管理平台</h2>
              <div class="login-input">
                  <el-form
                    :model="ruleForm"
                    :rules="verification?rules1:rules"
                    ref="ruleForm"
                    class="demo-ruleForm"
                  >
                    <el-form-item prop="phone">
                      <el-input
                        prefix-icon="el-icon-user"
                        v-model="ruleForm.phone"
                        placeholder="请输入手机号"
                      ></el-input>
                    </el-form-item>
                    <el-form-item prop="password" v-show="!verification">
                      <el-input
                        :type="passw"
                        prefix-icon="el-icon-lock"
                        v-model="ruleForm.password"
                        placeholder="请输入密码"
                      >
                        <i slot="suffix" :class="icon" @click="showPass"></i>
                      </el-input>
                    </el-form-item>
                    <el-form-item prop="code" v-show="!verification">
                      <div class="clientToken">
                        <el-input
                          prefix-icon="el-icon-lock"
                          v-model="ruleForm.code"
                          placeholder="请输入验证码"
                          :maxlength="4"
                        >
                        </el-input>
                        <img @click="changeImgUrl" :src="imgUrl"  alt="">
                      </div>
                    </el-form-item>
                    <el-form-item prop="captcha" v-show="verification">
                      <div class="login-code">
                        <el-input
                          type="text"
                          v-model="ruleForm.captcha"
                          placeholder="请输入验证码"
                        >
                        </el-input>
                      </div>
                    </el-form-item>
                    <!-- <el-form-item class="login-btnText">
                      <div class="login-btnText-div">
                        <span   @click="changeShowPage"
                          >验证码登陆</span
                        >
                        <el-link :underline="false" @click="toForget"
                          >忘记密码？</el-link
                        >
                      </div>
                    </el-form-item> -->
                    <el-form-item>
                      <el-button
                        class="login-btn"
                        type="primary"
                        @click="submitForm('ruleForm')"
                        >登 录</el-button
                      >
                    </el-form-item>
                  </el-form>
              </div>
            </div>
            <!-- <div class="login-rightImg">
              <img src="../../assets/img/3.png" alt="">
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="login-bottom">
      云南垦融林业发展有限公司版权所有
	   滇ICP备2026005797号-1<br />
      <!-- www.baowucarbon.com;
       ©2018-2019
      All Rights Reserved. -->
    </div>
  </div>
</template>

<script>
import { login,getCode,verificationCodeLogin,imageCode } from "@/api/api";
import { Encrypt } from "@/utils/secret.js";
export default {
  name: "login",
  data() {
    return {
      //用于显示或隐藏添加修改表单
      add: false,
      //用于改变Input类型
      passw: "password",
      //用于更换Input中的图标
      icon: "el-input__icon el-icon-view",
      verification:false,
      userCode: {
        code: "",
        businessId:"",
      },
      ruleForm: {
        phone: "",
        password: "",
        captcha:"",
        clientToken:"", // 随机字符串
        code:'',
      },
      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          // {
          //   validator: (rule, value, cb) => {
          //     if (/^1[3-9]\d{9}$/.test(value)) {
          //       cb();
          //     } else {
          //       cb(new Error("手机号格式错误"));
          //     }
          //   },
          // },
        ],
        password:[{ required: true, message: "请填写密码" }],
        code:[{ required: true, message: "请填写验证码" }],
        // password:[{ required: true, message: "请填写密码" },{min:8,message:'密码长度不小于8位'},{max:18,message:'密码长度不大于18位'},{pattern:/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,18}$/,message:'包括至少1个大写字母，1个小写字母，1个数字'}],
        // password: [
        //   { required: true, message: "请输入密码", trigger: "blur" },
        //   {
        //     min: 5,
        //     max: 18,
        //     message: "长度在 5 到 18 个字符",
        //     trigger: "blur",
        //   },
        // ],
      },
      rules1:{
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: (rule, value, cb) => {
              if (/^1[3-9]\d{9}$/.test(value)) {
                cb();
              } else {
                cb(new Error("手机号格式错误"));
              }
            },
          },
        ],
        captcha:[
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            min: 6,
            max: 6,
            message: "验证码格式错误",
            trigger: "blur",
          },
        ],
      },
      // 倒计时
      getTime: 60,
      isTime: true,
      timeItem: null,
      imgUrl:'', // 验证码图片路径
      num:6, // 控制点击次数
      timer:null
    };
  },
  methods: {
    // 获取验证码
    getCodeData() {
      getCode(this.ruleForm.phone).then((res) => {
        // console.log(res);
        if (res.data.code == "200") {
          this.isTime = false;
          this.timerData();
          this.userCode.businessId = res.data.data.businessId
          this.$message({
            message: "短信发送成功",
            type: "success",
          });
        }else{
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    // 倒计时
    timerData() {
      if (this.getTime > 0) {
        this.getTime--;
        this.timeItem = setTimeout(this.timerData, 1000);
      } else {
        this.isTime = true;
      }
    },
    // 切换验证码登录密码登录
    changeShowPage(){
      this.verification = !this.verification
      this.$nextTick(()=>{

        if(this.$refs.ruleForm) this.$refs.ruleForm.resetFields()
      })
    },
    // 点击登录
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            phone:that.ruleForm.phone
          }
          if(that.verification){
            data.captcha = that.ruleForm.captcha
            data.businessId = that.userCode.businessId
            verificationCodeLogin(data)
            .then(function (response) {
              // console.log(response);
              if(response.data.code === '200'){
                let data = response.data.data
                // console.log(data.os)
                // console.log(data.menus)
                if(data.user.osLongCode.split('!').length==1){
                  data.user.isCounty=false
                }else{
                  data.user.isCounty=true
                }
                // localStorage.setItem("organization",JSON.stringify(data.os))
                // localStorage.setItem("menus",JSON.stringify(data.menus))
                // localStorage.setItem("token", data.token);
                // localStorage.setItem("userInfo",JSON.stringify(data.user))
                // localStorage.setItem("baseUrl",data.contextPath)
                that.$message.success('登录成功')
                window.removeEventListener("keydown", that.keyDown, false);
                that.$router.push('/Home')

              }else{
                that.$message.error(response.data.message);
              }
            })
            .catch(function (error) {
              that.$message.error("用户名不存在或验证码错误");
            });

          }else{
            data.key = this.getUUID(16, 62)
            data.password = Encrypt(that.ruleForm.password,data.key,data.key)
            data.code = that.ruleForm.code
            data.clientToken = that.ruleForm.clientToken
            // data.code = that.ruleForm.code
            // data.password = that.ruleForm.password
            login(data)
            .then(function (response) {
              if (response.data.code == 200) {
                let data = response.data.data
                localStorage.setItem("token", data.token);
                localStorage.setItem("userInfo", JSON.stringify(data.user))
                localStorage.setItem("passWordFormat", data.passWordFormat)
                that.$router.push("/Home");
                that.$message.success('登录成功')
                window.removeEventListener("keydown", that.keyDown, false);
              } else {
                that.$message.error(response.data.message);
                that.changeImgUrl()
              }
            })
            .catch(function (error) {
              console.log(error);
              that.$message.error("用户名不存在或密码错误");
            });
          }
        } else {
          if(that.verification) that.$message.error("请输入正确的手机号和验证码");
          else that.$message.error("请输入正确的账号和密码");
          return false;
        }
      });
    },

    //密码的隐藏和显示
    showPass() {
      //点击图标是密码隐藏或显示
      if (this.passw == "text") {
        this.passw = "password";
        //更换图标
        this.icon = "el-input__icon el-icon-view";
      } else {
        this.passw = "text";
        this.icon = "el-input__icon el-icon-loading";
      }
    },
    // 忘记密码跳转页
    toForget() {
      //   this.$router.push("/forgetPassword");
    },
    keyDown(e) {
      //如果是回车则执行登录方法
      if (e.keyCode == 13) {
        this.submitForm("ruleForm");
      }
    },
    // 获取随机字符串
    getUUID(len, radix) {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
      var uuid = []
      var i
      radix = radix || chars.length
      if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
      } else {
        var r
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
        uuid[14] = '4'
        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | Math.random() * 16
            uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
          }
        }
      }
      return uuid.join('')
    },
    // // 获取验证码图片
    getImageCode(){
      let code = this.ruleForm.clientToken 
      imageCode(code)
    },

    // 点击验证码获取验证码图片
    changeImgUrl(){
      this.num--
      if(this.num>0){
        this.imgUrl = process.env.VUE_APP_SERVER_URL + '/login/imageCode/' + this.ruleForm.clientToken +'?code=' + this.getUUID(32, 16)
      }else{
        this.$message.error('获取验证码太频繁，请等候60秒')
        if(!this.timer){
          this.getImageCode()
          this.timer = setTimeout(()=>{
            this.num =5
            this.timer = null
            console.log('60');
          },60000)
        }
      }
    },
    getData(){
      this.ruleForm.clientToken = this.getUUID(32, 16)
      this.changeImgUrl()
    }
  },
  mounted() {
    window.addEventListener("keydown", this.keyDown);
    this.getData()
  },
};
</script>

<style scoped>
.login-conter{
    display: flex;
    align-items: center;
    height: 90px;
    justify-content: space-between;
}
.login-top{
    position: absolute;
    top: 0;
    width: 100%;
    height: 90px;
    z-index: 10;
    background-color: rgba(255, 255, 255, 0.685);
}
.login-left{
    
    height: 90px;
    display: flex;
    align-items: center;
}
.login-content{
    /* width: 180px; */
    padding: 15px 0px 15px 15px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background: #004593; */
}
.login-text{
    width: 140px;
    font-family: '微软雅黑';
    /* background: #fff; */
    font-size: 24px;
    font-weight: bold;
    letter-spacing:6px
}

.login-left img{
    /* width: 140px; */
    height: 80px;
    display: block;
}
.login-text img{
    /* width: 100px; */
    height: 34px;
    display: block;
}
.login-right{
    padding: 0 20px;
    display: flex;
    align-items: center;
}
.login-right i{
    margin: 0 5px;
    font-size: 20px;
}
.login-right .span{
    margin: 0 10px;
    color: #666;
}
.login-img{
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    /* z-index: -1; */
    /* height:  calc(100vh - 60px - 82px); */
    /* min-height: 860px; */
    background: #f3f3f3;
}
.login-bg{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 90vh;
}
/* .login-img img{
    width: 100%;
    height: 800px;
} */
.login-conterImg{
    position: absolute;
    /* width: 1200px; */
    /* left: 50%; */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* margin-left: -600px; */
    z-index: 1;
}
.login-conterImg-c{
    /* width: 1200px; */
    position: relative;
    padding: 0 20px;
    top: 50%;
    transform: translate3d(0,-50%,0);
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.login-conterLeft{
    position: absolute;
    top: 300px;
}
.login-conterLeft img{
    width: 314px !important;
    height: 42px;
}
.login-conterLeft p{
    color: #fff;
    font-size: 36px;
    /*box-shadow:  10px 10px 5px #000000;*/
}
.login-conterRight{
    /* width: 430px;
    height: 430px;
    background-color: rgba(255,255,255,0.9);
    border-radius: 30px;
    flex-shrink: 0; */
    /* position: absolute;
    top: 200px;
    right: 0;
    z-index: 2; */
}

.login-conterRight{
  padding-top: 30px;
  box-sizing: border-box;
  position: absolute;
  width: 430px;
  height: 380px;
  background-color: rgba(255,255,255,0.9);
  border-radius: 30px;
  right: 8%;
}
.login-conterRight h2{
    font-size: 24px;
    font-weight: normal;
    text-align: center;
    margin: 20px 0;
}
.login-input{
    width: 300px;
    margin: 0 auto;
}
.login-btnText{
    margin-top: -20px;
    text-align: right;
    line-height: normal;
    margin-bottom: 0;
}
.login-btnText .login-btnText-div{
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #606266;
}
.login-btnText-div>span{
    cursor: pointer;
}
.login-btn{
    width: 100%;
    padding: 15px 20px;
}

.login-code{
    display: flex;
}
.login-bottom{
    position: relative;
    z-index: 10;
    width: 100%;
    height: 10vh;
    padding: 20px 0;
    box-sizing: border-box;
    text-align: center;
    background: #fff;
}
.login-leftImg{
    /* position: absolute; */
    left: 0;
    top: 0;
    bottom: 0;
}
.login-conterImg-c img{
    
    /* height: 430px;
    display: block; */
}
.login-leftImg{
    margin-right: 20px;
}
.login-rightImg{
    margin-left: 20px;
}
/* .login-conter img{
  width: 40px;
  height: 40px;
} */
::v-deep .login-code .el-input__inner{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
::v-deep .login-code .el-button{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
.clientToken{
  display: flex;
  align-items: center;
}
.clientToken>img{
  width: 100px;
  height: 40px;
  background: #eee;
}
</style>
